import { gql } from '@apollo/client';

export const CATEGORIES = gql`
  query Categories {
    categories {
      id
      title
      company_id
      show_in_shell
      sell_periods {
        end
        start
      }
      goods {
        id
      }
    }
  }
`;

export const CREATE_CATEGORY = gql`
  mutation createCategory($input: CategoryInput!) {
    createCategory(input: $input) {
      id
      title
      company_id
      show_in_shell
      sell_periods {
        end
        start
      }
    }
  }
`;

export const DELETE_CATEGORY = gql`
  mutation deleteCategory($id: Int!) {
    deleteCategory(id: $id) {
      id
      title
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory($id: Int!, $input: CategoryInput!) {
    updateCategory(id: $id, input: $input) {
      id
      company_id
      title
      show_in_shell
      sell_periods {
        end
        start
      }
    }
  }
`;
